// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zuno-container {
  margin-top: 40px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.policy-card {
  border: none;
  border-radius: 20px;
  background: linear-gradient(135deg, #f9fbff, #eef6ff);
}

.policy-title {
  font-size: 1.6rem;
  font-weight: bold;
  color: #0d6efd;
  margin-bottom: 20px;
}

.policy-detail {
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 10px;
}

.download-btn {
  border-radius: 30px;
  font-weight: 500;
  padding: 10px 20px;
  transition: all 0.3s ease;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.loading-section {
  text-align: center;
  margin-top: 50px;
}
.download-btn {
  border: none;
  border-radius: 30px;
  font-weight: 600;
  padding: 12px 28px;
  font-size: 1rem;
  color: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
}

/* e-Proposal button */
.proposal-btn {
  background: linear-gradient(135deg, #007bff, #00c6ff);
  box-shadow: 0 4px 10px rgba(0, 123, 255, 0.3);
}

.proposal-btn:hover {
  background: linear-gradient(135deg, #0062cc, #00a4d6);
  transform: translateY(-3px);
  box-shadow: 0 6px 14px rgba(0, 123, 255, 0.45);
}

/* Policy Kit button */
.kit-btn {
  background: linear-gradient(135deg, #28a745, #5be584);
  box-shadow: 0 4px 10px rgba(40, 167, 69, 0.3);
}

.kit-btn:hover {
  background: linear-gradient(135deg, #218838, #4cd97b);
  transform: translateY(-3px);
  box-shadow: 0 6px 14px rgba(40, 167, 69, 0.45);
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/ZUNO/ZunoPolicydownload.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD","sourcesContent":[".zuno-container {\r\n  margin-top: 40px;\r\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.policy-card {\r\n  border: none;\r\n  border-radius: 20px;\r\n  background: linear-gradient(135deg, #f9fbff, #eef6ff);\r\n}\r\n\r\n.policy-title {\r\n  font-size: 1.6rem;\r\n  font-weight: bold;\r\n  color: #0d6efd;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.policy-detail {\r\n  font-size: 1.1rem;\r\n  color: #333;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.download-btn {\r\n  border-radius: 30px;\r\n  font-weight: 500;\r\n  padding: 10px 20px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.download-btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.loading-section {\r\n  text-align: center;\r\n  margin-top: 50px;\r\n}\r\n.download-btn {\r\n  border: none;\r\n  border-radius: 30px;\r\n  font-weight: 600;\r\n  padding: 12px 28px;\r\n  font-size: 1rem;\r\n  color: #fff;\r\n  transition: all 0.3s ease;\r\n  cursor: pointer;\r\n}\r\n\r\n/* e-Proposal button */\r\n.proposal-btn {\r\n  background: linear-gradient(135deg, #007bff, #00c6ff);\r\n  box-shadow: 0 4px 10px rgba(0, 123, 255, 0.3);\r\n}\r\n\r\n.proposal-btn:hover {\r\n  background: linear-gradient(135deg, #0062cc, #00a4d6);\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 6px 14px rgba(0, 123, 255, 0.45);\r\n}\r\n\r\n/* Policy Kit button */\r\n.kit-btn {\r\n  background: linear-gradient(135deg, #28a745, #5be584);\r\n  box-shadow: 0 4px 10px rgba(40, 167, 69, 0.3);\r\n}\r\n\r\n.kit-btn:hover {\r\n  background: linear-gradient(135deg, #218838, #4cd97b);\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 6px 14px rgba(40, 167, 69, 0.45);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
